import { render, staticRenderFns } from "./DefaultPosterTemp.vue?vue&type=template&id=4726e8a2&scoped=true"
import script from "./DefaultPosterTemp.vue?vue&type=script&lang=js"
export * from "./DefaultPosterTemp.vue?vue&type=script&lang=js"
import style0 from "./DefaultPosterTemp.vue?vue&type=style&index=0&id=4726e8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4726e8a2",
  null
  
)

export default component.exports